













































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import { EUserPermissions, EUserStatus, IChain, IFacility, IUser, IUserChainRole } from '@zunta/configurations'
import Icon from '@/components/Icon.vue'
import Switcher from '@/components/Switcher.vue'
import { UserModule } from '@/store/modules/user.module'
import { FacilityModule } from '@/store/modules/facility.module'
import { PermissionsModule } from '@/store/modules/permissions.module'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import Api from '@/api'
import { User } from '@/classes/User'

import Table from '@/components/tables/Table.vue'
import Card from '@/components/Card.vue'
import DisableUserModal from '@/views/app/management/settings/components/DisableUserModal.vue'
import { getTooltipListText } from '@/utils/helpers'

@Component({
  components: {
    DisableUserModal,
    Card,
    Table,
    Icon,
    Switcher
  }
})
export default class ManagementUsers extends Vue {
  permissionsModuleInstance: PermissionsModule = getModule(PermissionsModule, this.$store)
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  EUserPermissions: any = EUserPermissions
  EUserStatus: any = EUserStatus
  user: any = Api.getUser() as User

  getTooltipListText: Function = getTooltipListText

  selectedUser?: IUser | null = null

  needsConfirmDisableUserId: number = -1

  get config (): ITableConfig {
    return {
      clearFilterBtn: {
        wrapperClass: 'position-absolute',
        wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
        class: 'rounded-bottom'
      },
      usePagination: true,
      useQuery: true,
      fetchFunction: this.getManagementUsersList,
      rowClick: this.goUserEditPage,
      maxHeight: 'calc(100vh - 365px)',
      minHeight: 'calc(100vh - 365px)',
      columns: [
        {
          minWidth: '200px',
          width: 16.6,
          key: 'name',
          searchKey: 'name',
          label: 'Name',
          hasSort: true,
          hasSearch: true,
          type: ETableColumnType.default
        },
        {
          minWidth: '200px',
          width: 20.6,
          key: 'role',
          searchKey: 'role',
          label: 'Role',
          hasSort: true,
          hasSearch: true,
          type: ETableColumnType.multiselect,
          options: this.rolesListItems
        },
        {
          minWidth: '100px',
          width: 16.6,
          // class: 'text-center',
          key: 'facilityId',
          searchKey: 'facilityId',
          label: 'Facilities',
          hasSort: true,
          hasSearch: true,
          type: ETableColumnType.select,
          options: this.getFacilityItems
        },
        {
          minWidth: '200px',
          width: 20.6,
          key: 'email',
          searchKey: 'email',
          label: 'Email',
          hasSort: true,
          hasSearch: true,
          type: ETableColumnType.default
        },
        {
          minWidth: '200px',
          width: 16.6,
          key: 'phone',
          searchKey: 'phone',
          label: 'Phone',
          hasSort: true,
          hasSearch: true,
          type: ETableColumnType.default
        },
        {
          minWidth: '100px',
          width: 8.6,
          class: 'text-right',
          key: 'actions'
        }
      ]
    }
  }

  get rolesList () {
    return this.$store.state.permissions.roles
  }

  get rolesListItems () {
    return this.rolesList.map((role: IUserChainRole) => ({
      value: role.id,
      key: role.id,
      content: role.name
    }))
  }

  get userList () {
    return this.$store.state.user.users
  }

  get userTotal () {
    return this.$store.state.user.total
  }

  get facilities () {
    return this.$store.state.facility.facilities
  }

  getFacilityItems () {
    return [{
      key: 'all',
      value: 'all',
      content: 'All'
    }].concat(this.facilities.map((facility: IFacility) => {
      return {
        key: facility.id,
        value: `${facility.id}`,
        content: facility.name
      }
    }))
  }

  mounted () {
    this.facilityModuleInstance.getFacilityList({})
    this.permissionsModuleInstance.getUserRoles()
  }

  goUserEditPage (user: IUser) {
    if (!this.user.hasPermissionFor(EUserPermissions.MODIFY_USERS)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: `Modify User`,
        icon: 'warning'
      })
      return
    }

    this.$locationManager.rememberAndGoTo({
      name: 'management-users-edit',
      params: { userId: user.id.toString() }
    })
  }

  async getManagementUsersList ({ ...filters }) {
    await this.userModuleInstance.getManagementUsersList({ ...filters, getUsersWithSamePermissions: true })
  }

  async changeUserStatus (userId: number, active: boolean) {
    if (!this.user.hasPermissionFor(EUserPermissions.MODIFY_USERS) && !this.user.isAdmin()) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: `Modify User`,
        icon: 'warning'
      })
      return
    }

    if (!active) {
      // @ts-ignore
      this.$refs.table.isLoading = true
      await this.userModuleInstance.checkUserAssignments({ userId })
      // @ts-ignore
      this.$refs.table.isLoading = false

      if (this.userModuleInstance.userAssignments && this.userModuleInstance.userAssignments.length) {
        this.needsConfirmDisableUserId = userId
        return
      }
    }

    await this.updateUserStatus(userId, active)
  }

  async updateUserStatus (userId: number, active: boolean) {
    this.needsConfirmDisableUserId = -1
    await this.userModuleInstance.updateStatus({
      id: userId,
      status: active ? EUserStatus.ACTIVE : EUserStatus.NOT_ACTIVE
    })
  }

  userFacilities (facilities: IFacility[]): any[] {
    const userFacilities: any[] = []
    if (facilities && facilities.length) {
      facilities.forEach((facilityId: any) => {
        const facility = this.facilities.find((facility: any) => facility.id === Number(facilityId))
        if (facility) {
          userFacilities.push(facility)
        }
      })
    }
    return userFacilities
  }

  goAddUser () {
    this.userModuleInstance.resetSelectedUser()
    this.$locationManager.rememberAndGoTo({ name: 'management-users-edit', params: { userId: 'new' } })
  }
}
